export default "__VITE_ASSET__CYFATc8d__"